var map = {
	"./ACGIH-Heavy": 400,
	"./ACGIH-Heavy.json": 400,
	"./ACGIH-Light": 401,
	"./ACGIH-Light.json": 401,
	"./ACGIH-Moderate": 402,
	"./ACGIH-Moderate.json": 402,
	"./ACSM-Acclimatized": 403,
	"./ACSM-Acclimatized.json": 403,
	"./ACSM-NonAcclimatized": 404,
	"./ACSM-NonAcclimatized.json": 404,
	"./GaStateHighSchool": 405,
	"./GaStateHighSchool.json": 405,
	"./KyStateHighSchool": 406,
	"./KyStateHighSchool.json": 406,
	"./NATA": 407,
	"./NATA.json": 407,
	"./NcStateHighSchool": 408,
	"./NcStateHighSchool.json": 408,
	"./NjStateHighSchool": 409,
	"./NjStateHighSchool.json": 409,
	"./TBMed507-Easy": 410,
	"./TBMed507-Easy.json": 410,
	"./TBMed507-Hard": 411,
	"./TBMed507-Hard.json": 411,
	"./TBMed507-Moderate": 412,
	"./TBMed507-Moderate.json": 412,
	"./UsaSoccer-Cat1": 413,
	"./UsaSoccer-Cat1.json": 413,
	"./UsaSoccer-Cat2": 414,
	"./UsaSoccer-Cat2.json": 414,
	"./UsaSoccer-Cat3": 415,
	"./UsaSoccer-Cat3.json": 415,
	"./VtStateHighSchool": 416,
	"./VtStateHighSchool.json": 416,
	"./_HeatStressGuidelinesIndex": 321,
	"./_HeatStressGuidelinesIndex.json": 321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 604;